import { yupResolver } from "@hookform/resolvers/yup";
import React, { useEffect, useMemo, useState } from "react";
import { Button, Card, Col, Form, Row } from "react-bootstrap";
import { FormProvider, useForm } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
import * as yup from "yup";
import FiscalYearBasicInformation from "./FiscalYearBasicInformation";
import { toast } from "react-toastify";
import { FiscalYearAPI } from "api";
import { customSettings } from "utils/customConfig";
import moment from "moment";
import { useSettingContext } from "context/SettingContext";
import { useSettingValue } from "hooks/useSettingValue";
import PageTitle from "utils/PageTitle";

const schema = yup
  .object({
    code: yup.string(),
    name: yup.string(),
    costCenterId: yup.string(),
    startDate: yup.string(),
    endDate: yup.string(),
    isCurrent: yup.boolean(),
    fiscalPeriods: yup
      .array()
      .of(
        yup.object().shape({
          code: yup.string(),
          name: yup.string(),
          startDate: yup.string(),
          endDate: yup.string(),
          isClosed: yup.boolean(),
        })
      )
      .required("Fiscal period is required"),
    status: yup.boolean(),
  })
  .required();

const AddFiscalYear = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(false);

  const submittedValues = {};
  const methods = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      fiscalPeriods: [{}],
    },
  });
  const { handleSubmit, reset, setValue } = methods;

  // const settingsData = useSettingContext();
  // const costCenter = useMemo(
  //   () => settingsData?.find((d) => d.name === "DEFAULT_COST_CENTER"),
  //   [settingsData]
  // );
  // const costCenterId = Number(costCenter?.value); // Ensure it's a number

  const costCenterId = useSettingValue("DEFAULT_COST_CENTER");

  const onSubmit = async (data) => {
    let myData = {
      ...data,
      id: location?.state?.id ?? 0, // Use nullish coalescing to handle undefined or null
      costCenterId: costCenterId,
      fiscalPeriods: data.fiscalPeriods?.map((d) => {
        return {
          ...d,
          code: d.name,
          startDate: moment(d.startDate).format("YYYY-MM-DD"),
          endDate: moment(d.endDate).format("YYYY-MM-DD"),
        };
      }),
    };

    // console.log(myData);

    try {
      if (location?.state) {
        setLoading(true);
        await FiscalYearAPI.post(myData);
        setLoading(false);
        toast.success("Fiscal Year Updated Successfully", {
          position: customSettings.toastPosition,
          autoClose: customSettings.toastClose,
        });
      } else {
        setLoading(true);
        await FiscalYearAPI.post(myData);
        setLoading(false);
        toast.success("Fiscal Year Created Successfully", {
          position: customSettings.toastPosition,
          autoClose: customSettings.toastClose,
        });
      }

      // ------- Get all object keys form data and set empty values to reset ------------
      const keys = Object.keys(data);
      for (const key of keys) {
        submittedValues[key] = "";
      }
      reset({ ...submittedValues });
      navigate(-1);
    } catch (error) {
      toast.error("Something Went Wrong", {
        position: customSettings.toastPosition,
        autoClose: customSettings.toastClose,
      });
      console.log(error);
    }
  };

  useEffect(() => {
    if (location.state) {
      const {
        code,
        name,
        costCenterId,
        startDate,
        endDate,
        isCurrent,
        fiscalPeriods,
        status,
      } = location.state;

      // Ensure fiscalPeriods is an array before processing
      const formattedFiscalPeriods = Array.isArray(fiscalPeriods)
        ? fiscalPeriods.map((period) => ({
            ...period,
            startDate: period?.startDate
              ? moment.utc(period.startDate).format("YYYY-MM-DD")
              : "",
            endDate: period?.endDate
              ? moment.utc(period.endDate).format("YYYY-MM-DD")
              : "",
          }))
        : [];

      setValue("code", code);
      setValue("name", name);
      setValue("costCenterId", costCenterId);
      setValue("isCurrent", isCurrent);
      setValue("status", status);
      setValue("fiscalPeriods", formattedFiscalPeriods); // Set formatted array

      let startDateFormat = startDate ? moment.utc(startDate) : null;
      const startDateFormatted = startDateFormat
        ? startDateFormat.format("YYYY-MM-DD")
        : "";

      let endDateFormat = endDate ? moment.utc(endDate) : null;
      const endDateFormatted = endDateFormat
        ? endDateFormat.format("YYYY-MM-DD")
        : "";

      setTimeout(() => {
        setValue("startDate", startDateFormatted);
        setValue("endDate", endDateFormatted);
      }, 200);
    }
  }, [setValue, location.state]);

  return (
    <>
      {/* <div className="py-2">
        <BreadCrumb />
      </div> */}

      <PageTitle name=" Accounts | Fiscal Year" />

      <FormProvider {...methods}>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Card>
            <Card.Header className="border-bottom">
              <Row className="flex-between-center ">
                <Col md>
                  <h5 className="fs-9 text-nowrap mb-2 mb-md-0">
                    {" "}
                    Accounts | Fiscal Year
                  </h5>
                </Col>
                <Col xs="auto">
                  <Button
                    variant="link"
                    className="text-secondary fw-medium p-0 me-3"
                    type="button"
                    onClick={() => navigate(-1)}
                  >
                    Cancel
                  </Button>
                  <Button variant="primary" type="submit" disabled={loading}>
                    Ok
                  </Button>
                </Col>
              </Row>
            </Card.Header>
            <FiscalYearBasicInformation />

            {/* <FiscalPeriodTable /> */}
            {/* <Row className="">
            
              <Col lg={12}>
              </Col> */}
            {/* <Col xs={12}>
    
            </Col> */}
            {/* </Row> */}
          </Card>
        </Form>
      </FormProvider>
    </>
  );
};

export default AddFiscalYear;
